import PropTypes from 'prop-types'
import Ratings from 'shared/components/rating'
import css from '../info-fields.css'

const Rating = ({ value, onChange, allowUnrated }) => (
    <div className={css.field}>
        <label className={css.label}>Rating</label>
        <Ratings value={value} onChange={rating => onChange({ rating })} allowUnrated={allowUnrated} />
    </div>
)

Rating.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
}

export default Rating
